import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonKentimataAbove';
const args = {};

export class OligonKentimataAbove extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
